import { APP_CONFIG } from "app.config";

export const TYPE_TREE = {
    READ_ONLY: 'READ_ONLY'
};

export const TIMER = {
    TIMER_FOR_BUILD_COLUMN_AG_GRID: 300,
    ONE_MINUTE: -60,
    ONE_WEEK: 7,
    NINETY_DAY: 90
};

export const SCREEN = {
    UNIT_SCREEN: 'UNIT_SCREEN',
    EMPLOYEE_SCREEN: 'EMPLOYEE_SCREEN'
};

export const USER_SETTING = {
    FORMAT_DAY_MONTH_YEAR_DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
    FORMAT_DAY_MONTH_YEAR_DATE: 'DD/MM/YYYY',
    FORMAT_TIME: 'HH:mm:ss',
    FORMAT_MONTH_DAY_YEAR_DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
    FORMAT_MONTH_DAY_YEAR_DATE: 'MM/DD/YYYY'
};

export const COMMON_CONSTANT = {
    MENU_ORGANIZATION: 'general'
};

export const COMMON_VARIABLE = {
    ALL_CODE: 'ALL',
    USER_NOT_FOUND: 'USER_NOT_FOUND'
};

export const USER_URL = {
    CREATE_USER: APP_CONFIG.MCR_US_PROFILE + "userProfile/create",
    SEARCH_USER: APP_CONFIG.MCR_US_PROFILE + "/userProfile/pivotPagingWithSecInfo",
    UPDATE_USER: APP_CONFIG.MCR_US_PROFILE + "userProfile/update",
    UPDATE_RECORD_STATUS: APP_CONFIG.MCR_US_PROFILE + "userProfile/disable",
    GET_BY_AGG_ID: APP_CONFIG.MCR_US_PROFILE + "userProfile/getByAggId?aggId=",
    PIVOT_COUNT: APP_CONFIG.MCR_US_PROFILE + "userProfile/pivotCountWithSecInfo",
    GET_ROLE_BY_AGGID: APP_CONFIG.MCR_US_PROFILE + "userProfile/getRolesOfUser?aggId=",
    GET_ALL_ROLE: APP_CONFIG.MCR_SECMT_API + "account/getRoles",
    ASSIGN_ROLE_USER: APP_CONFIG.MCR_US_PROFILE + "userProfile/assignRoleOfUser",
    QUICK_SEARCH_USER: APP_CONFIG.MCR_US_PROFILE + "userProfile/quickSearch",
    LINK_SETUP_PASSWORD: APP_CONFIG.MCR_US_PROFILE + "userProfile/getUrlUserInvite",
    LINK_RESET_PASSWORD: APP_CONFIG.MCR_US_PROFILE + "userProfile/getUrlResetPass",
    CURRENT_APP: APP_CONFIG.MCR_US_PROFILE + "userProfile/getCurrentUserApp"
};

export const USER = {
    NAVIGATE_PAGE_CREATE: `${COMMON_CONSTANT.MENU_ORGANIZATION}/user/create`,
    NAVIGATE_PAGE_LIST: `${COMMON_CONSTANT.MENU_ORGANIZATION}/user`,
    NAVIGATE_PAGE_DETAIL: `${COMMON_CONSTANT.MENU_ORGANIZATION}/user/`,
    NAVIGATE_PAGE_AUTHORIZATION_DETAIL: `${COMMON_CONSTANT.MENU_ORGANIZATION}/user/authorization/`,
    NO_DATA: "No data",
    EMAIL_EXISTED: "EMAIL.EXISTED",
    EMP_CODE_NOT_FOUND: "EMP_CODE.NOT_FOUND",
    EMP_CODE_EXISTED: "EMP_CODE.EXISTED",
    LINK_URL: `#/${COMMON_CONSTANT.MENU_ORGANIZATION}/user`,
    ERROR_ID_UNACTIVE: "validation.user.unactive",
    EMAIL_SETUP_PASSWORD: "emailSetupPassword",
    EMAIL_RESET_PASSWORD: "emailResetPassword"
};